import React from "react";
import { auditTrustmark } from "../../images";
import { Box, Typography, Button } from "@mui/material";

const Audit = () => {
	return (
		<Box
			sx={{
				width: "90%",
				maxWidth: "700px",
				margin: "4rem auto",
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				textAlign: "center",
				padding: "1.5rem",
				border: "1px solid #e0e0e0",
				borderRadius: "12px",
				boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
				backgroundColor: "#fff",
			}}
		>
			<Typography variant="h5" sx={{ fontWeight: 600, mb: 2, color: "#004225" }}>
				NDPR Audit Compliance Trustmark
			</Typography>

			<Typography sx={{ mb: 3, color: "#5E5E5E", fontSize: "16px" }}>
				Zikora Microfinance Bank has successfully completed its NDPR Audit for 2025 and is
				compliant with the Nigeria Data Protection Regulation.
			</Typography>

			<Box
				component="img"
				src={auditTrustmark}
				alt="NDPR Audit Trustmark - Zikora MFB"
				sx={{
					width: "100%",
					maxWidth: "550px",
					borderRadius: "8px",
					boxShadow: "0 0 10px rgba(0,0,0,0.1)",
				}}
			/>

			<Typography sx={{ mt: 2, color: "#333", fontSize: "14px" }}>
				Scan the QR code to verify, or click the button below.
			</Typography>

			<Button
				variant="contained"
				sx={{
					mt: 3,
					backgroundColor: "#006400",
					":hover": { backgroundColor: "#004d00" },
				}}
				href="https://services.ndpc.gov.ng/portal/?page=verify-c&d=ang38615182840&id=55851&sn=215bad70d900bd7093e8bbe782bbb56e&t=audit_filing&tp=nwp_audit"
				target="_blank"
				rel="noopener noreferrer"
			>
				Verify Trustmark
			</Button>
		</Box>
	);
};

export default Audit;
